import { scrollToCompletelyVisible } from "../../portal/dom/smoothScroll";
import { getExpectedHeight } from "../dom/measure";

/**
 * Element which opens/closes a linked element if clicked.
 *
 * @author bgr
 */
export class Toggle extends HTMLElement {
	constructor() {
		super();
		this.isOpen = false;
		this.toggable = null;
	}

	connectedCallback() {
		const toggableContainer = this.toggableContainer || document;
		this.toggable = toggableContainer.querySelector(
			this.getAttribute("toggable-selector"),
		);
		this.toggable.style.display = "none";
		this.toggable.classList.add("toggable");
		this.addEventListener("click", () => {
			this[this.isOpen ? "close" : "open"]();
		});
	}

	open() {
		if (this.isOpen) {
			return;
		}
		this.toggable.style.display = "";

		this.isOpen = true;
		this.classList.add("toggle--open");
		this.updateHeight();
	}

	async updateHeight() {
		const targetHeight = await getExpectedHeight(this.toggable);

		const addOpenClass = () => {
			if (this.open) {
				this.toggable.classList.add("toggable--open");
			}
			this.toggable.removeEventListener("transitionend", addOpenClass);
		};
		this.toggable.addEventListener("transitionend", addOpenClass);

		// Transition fails if height is set here immediately after
		// calling getExpectedHeight()
		setTimeout(() => {
			if (!this.isOpen) {
				return;
			}
			this.toggable.style.height = `${targetHeight}px`;
			scrollToCompletelyVisible(this.toggable, targetHeight);
			this.dispatchEvent(new CustomEvent("open"));
		}, 10);
	}

	close() {
		if (!this.isOpen) {
			return;
		}
		this.isOpen = false;
		this.classList.remove("toggle--open");
		this.toggable.classList.remove("toggable--open");
		this.toggable.style.height = "0px";

		const hideToggable = () => {
			if (!this.isOpen) {
				this.toggable.style.display = "none";
			}
			this.toggable.removeEventListener("transitionend", hideToggable);
		};
		this.toggable.addEventListener("transitionend", hideToggable);
		this.dispatchEvent(new CustomEvent("close"));
	}
}

customElements.define("esc-toggle", Toggle);
